import { AddressModel } from '@steelbuy/ts-shared';

import { InvoiceAddressCollectionData } from './InvoiceAddressCollectionData';
import { useCollectionData } from '../../util/consumer/CollectionConsumerHook';

export const useInvoiceAddressCollectionData = () => useCollectionData<AddressModel>(InvoiceAddressCollectionData);
